var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { colorsPreset } from './colorsPreset';
import { PickerPanel } from './style';
var ColorPanel = /** @class */ (function (_super) {
    __extends(ColorPanel, _super);
    function ColorPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.getBgColorIdxByName = function (selectedColor) {
            if (selectedColor) {
                for (var i = 0; i < colorsPreset.length; i++) {
                    var color = colorsPreset[i];
                    if (color.name === selectedColor.name) {
                        return i;
                    }
                }
            }
            return -1;
        };
        _this.onChangeColorHandler = function (selectedBgIdx, selectedColor) {
            _this.setState({ selectedColor: selectedColor });
            if (_this.props.onChangeColor) {
                _this.props.onChangeColor(selectedColor);
            }
        };
        _this.state = {
            selectedColor: _this.props.selectedColor,
        };
        return _this;
    }
    ColorPanel.prototype.render = function () {
        var _this = this;
        var selectedColorIdx = this.getBgColorIdxByName(this.state.selectedColor);
        var colors = colorsPreset.map(function (color, idx) { return (React.createElement("div", { onClick: function () { return _this.onChangeColorHandler(idx, color); }, key: "bg-color-" + idx, className: "color-palette", style: { background: "linear-gradient(-45deg, " + color.top + " 0%, " + color.bottom + " 100%)" } },
            React.createElement("span", { id: "target" + idx, className: "color-active target " + (selectedColorIdx === idx ? 'selected' : '') }))); });
        return (React.createElement(PickerPanel, null,
            React.createElement("div", { className: "panel-container" },
                React.createElement("div", { className: "color-container" }, colors))));
    };
    return ColorPanel;
}(React.Component));
export default ColorPanel;
//# sourceMappingURL=colorPanel.js.map